// @flow
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import type { QuestionType, ThemeType } from 'types/Faq';

export type StateProps = {
  themes?: Array<ThemeType>,
  questions: Array<QuestionType>
};

type Props = {
  match: {
    params: {
      slugTheme: string
    }
  }
} & StateProps;

class ContactList extends PureComponent<Props> {
  static defaultProps = {
    theme: ''
  };

  renderQuestions = (filteredQuestions: Array<QuestionType>): any => {
    const { themes } = this.props;

    if (!themes || themes.length === 0) {
      return null;
    }

    return filteredQuestions.map(question => {
      const filteredTheme = themes.filter(theme => theme.id === question.theme);

      // https://www.codementor.io/blog/react-optimization-5wiwjnf9hj#9-avoid-using-index-as-key-for-map */
      return (
        <Link
          to={`/faq/${filteredTheme[0].slug}/${question.slug}`}
          key={question.slug}
          className="link-chevron link-chevron--din"
          data-label=""
        >
          <span>{question.title}</span>
          <i className="icon icon-chevron-right"></i>
        </Link>
      );
    });
  };

  render() {
    const { questions, themes } = this.props;
    const { slugTheme } = this.props.match.params;

    if (!themes || themes.length === 0) {
      return null;
    }

    const filteredThemes = themes.filter(theme => theme.slug === slugTheme);

    if (filteredThemes.length === 0) {
      return null;
    }
    const filteredQuestions = questions.filter(question => question.theme === filteredThemes[0].id);

    return (
      <React.Fragment>
        {filteredQuestions.length > 0 && (
          <div className="block-contact__faq">
            <h3>Cela pourrait vous être utile</h3>
            {this.renderQuestions(filteredQuestions)}
          </div>
        )}

        <div className="block-contact__write">
          <h4 className="ft-h3">Vous ne trouvez pas ce que vous cherchez ?</h4>
          <p>Envoyez-nous un message, nous vous répondrons aussi rapidement que possible.</p>
          <Link to={`/contact/nous-contacter?q=${slugTheme}`}>
            <button className="btn btn--primary js-contact-write">Nous écrire</button>
          </Link>
        </div>
      </React.Fragment>
    );
  }
}

export default ContactList;
